import { Engagement } from "@oysterhr/schema"
import { Alert } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"

type HighAmountSupplementAlertArgs = {
  amount?: number | string
  engagement?: Engagement | null
}
export function HighAmountSupplementAlert({ amount, engagement }: HighAmountSupplementAlertArgs) {
  const { t } = useTranslation("PaySupplements")

  const monthlySalary = engagement?.contract
    ? engagement.contract.salary
    : (engagement?.employment?.salaryAmount ?? 0) / 12

  if (!monthlySalary || !amount || monthlySalary > Number(amount)) return null

  return (
    <Alert variation="warning">
      <Alert.Icon />
      <Alert.Content>{t("supplementAmountHigherThanSalary")}</Alert.Content>
    </Alert>
  )
}
